import React, { useEffect, useState } from 'react';
import { NavLink, BrowserRouter as Router, Route, Routes, Link, Navigate, useLocation } from 'react-router-dom';
import './App.css'; // Your existing styles
import { FaFacebookF, FaInstagram, FaTwitter, FaPinterestP, FaYoutube } from 'react-icons/fa';

const Footer = () => {
    return (
        <footer
            className="footer"
            id="contact"
            style={{

                backgroundSize: "cover",
                backgroundPosition: "center",
                backgroundRepeat: "no-repeat",
                color: "black",
            }}
        >
            <div className="section__container footer__container">
                <div className="footer__col">
                    <div className="logos">
                      <Link to="/cover">
                        <img src={`${process.env.PUBLIC_URL}/images/login2.png`} />
                      </Link>
                      <div className="logo-containerss">
                        <h1 className="logo-title">WASALA TOURS</h1>
                        <p className="logo-subtitle">~ Your Tour Planning Experts ~</p>
                      </div>
                    </div>

                    <p className="section__description">
                        Your journey starts with us as your guide, <br />
                        To places where dreams and moments collide <br />
                    </p>

                    <div className="social-media-section">
                          <h3 className="social-heading">CONNECT WITH US</h3>
                          <div className="icon-container">
                            <Link to="https://www.facebook.com/WasalaTours" className="social-icon"><FaFacebookF /></Link>
                            <Link to="https://www.instagram.com/wasala_tours" className="social-icon"><FaInstagram /></Link>

                          </div>
                        </div>
                </div>

                <div className="footer__col">
                    <h4>Quick Links</h4>
                    <ul className="footer__links">
                        <li><Link to="/cover">HOME</Link></li>
                        <li><Link to="/about">ABOUT US</Link></li>
                        <li><Link to="/service">SERVICE</Link></li>
                        <li><Link to="/gallery">GALLERY</Link></li>
                        <li><Link to="/contactus">CONTACT US</Link></li>
                    </ul>
                </div>

                <div className="footer__col">
                    <h4>Our Services</h4>
                    <ul className="footer__links">
                        <li><Link to="/srilankatours">SRI LANKAN TOUR</Link></li>
                        <li><Link to="/chinatours">CHINA TOUR</Link></li>
                    </ul>
                </div>

                <div className="footer__col">
                    <h4>Wasala Tours</h4>
                   <ul className="contact-list">
                     <li><strong>Contact No:</strong> <br/> +94-719898789</li>
                     <li><strong>Email:</strong><br/> wasalatours18@gmail.com</li>
                     <li><strong>Address:</strong><br/> No.103/1A, Rathna Mawatha, Makuluduwa, Piliyandala.</li>
                     <li className="wechat-item">
                       <strong>WeChat:</strong> <br/>Scan the QR code to connect
                       <div className="wechat-qr-container">
                         <img src="./images/QR.jpeg"  className="wechat-inline-image" />
                       </div>
                     </li>
                     <li className="copyright">
                       <strong>© 2025 Wasala Tours. All rights reserved.</strong>
                     </li>
                   </ul>

                </div>
            </div>


        </footer>
    );
};

export default Footer;
